// Global
import React from 'react';

// local
import { Content } from '@generated/Content/ContentTabs.model';
import { ContentTabs, TabItem } from './ContentTabs';
import PlainTextWrapper from 'components/helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import RichTextWrapper from 'components/helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import ImageWrapper from 'components/helpers/SitecoreWrappers/ImageWrapper/ImageWrapper';
import { usePreambleFields } from 'components/helpers/Molecules/Preamble/Preamble.sitecore';
import useIsEditing from 'lib/hooks/sitecore/useIsEditing';
import { getComponentCss } from 'lib/utils/sitecore/component-css';
import { ImageField } from '@sitecore-content-sdk/nextjs';
import { MAX_CONTENT_TABS } from 'lib/constants/sitecore';
type ContentTabsProps = Content.ContentTabs.ContentTabs_Component;

export const Default = (props: ContentTabsProps) => {
  /*
   * Data Processing
   */
  const preambleFields = usePreambleFields({
    fields: props.fields,
  });
  const isEditing = useIsEditing();
  const showPreamble = props.fields?.showPreamble?.value;

  // Check if preamble has any content
  const hasPreambleContent = !!(
    preambleFields?.headlineEyebrow ||
    preambleFields?.headline ||
    preambleFields?.headlineSubhead ||
    preambleFields?.headlineDescription ||
    preambleFields?.cta1 ||
    preambleFields?.cta2
  );

  //   In editing mode, always render the component even if empty so it can be edited
  //   In non-editing mode, render if there are tabs OR if there's preamble content
  if (!props.fields?.tabItems || props.fields.tabItems.length === 0) {
    if (isEditing || (showPreamble && hasPreambleContent)) {
      return (
        <ContentTabs
          showPreamble={showPreamble ?? true}
          tabs={[]}
          className={getComponentCss(props)}
          preamble={preambleFields}
        />
      );
    }
    return <></>;
  }

  const tabs: TabItem[] = (props.fields.tabItems as Content.ContentTabs.TabItem_Item[]).map(
    (tabItem, index: number) => ({
      id: tabItem.id || index.toString(),
      // Show image if it has a src, OR in editing mode (to allow adding images in Page Builder)
      image: tabItem.fields?.image?.value?.src ? (
        <ImageWrapper field={tabItem.fields.image as ImageField} />
      ) : isEditing && tabItem.fields?.image ? (
        <ImageWrapper field={tabItem.fields.image as ImageField} />
      ) : undefined,
      heading: <PlainTextWrapper field={tabItem.fields?.heading} />,
      // Show content if it has a value, OR in editing mode (to allow adding content in Page Builder)
      content: tabItem.fields?.content?.value ? (
        <RichTextWrapper field={tabItem.fields?.content} />
      ) : isEditing && tabItem.fields?.content ? (
        <RichTextWrapper field={tabItem.fields?.content} />
      ) : undefined,
    })
  );

  return (
    <ContentTabs
      preamble={preambleFields}
      showPreamble={showPreamble}
      tabs={tabs.slice(0, MAX_CONTENT_TABS)} // Limiting to first 4 tabs for example
    />
  );
};
